export const leaveFormListRoute = {
    path: "/travel",
    name: "leave-form-list",
    component: () => import("../ui/leave-form/leave-form-list.vue")
};